import { render } from "./cohortPivot.vue?vue&type=template&id=5248c0ef&scoped=true"
import script from "./cohortPivot.vue?vue&type=script&lang=js"
export * from "./cohortPivot.vue?vue&type=script&lang=js"

import "./cohortPivot.vue?vue&type=style&index=0&id=5248c0ef&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5248c0ef"]])

export default __exports__